<template>
  <div class="h-2 w-full bg-gray-200 mt-2 rounded">
    <div
      class="h-2 rounded animated-bar"
      :class="{
        'w-0': value.length < minLength,
        'w-1/5': value.length >= minLength && result.score === 0,
        'w-2/5': value.length >= minLength && result.score === 1,
        'w-3/5': value.length >= minLength && result.score === 2,
        'w-4/5': value.length >= minLength && result.score === 3,
        'w-full': value.length >= minLength && result.score === 4,
        'bg-red-400': result.score <= 1,
        'bg-orange-400': result.score === 2,
        'bg-yellow-400': result.score === 3,
        'bg-green-400': result.score === 4
      }"
    />
  </div>
</template>

<script>
const zxcvbn = require('zxcvbn')

export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      minLength: 8,
      dictionary: [
        'indiefilmlab',
        'indiefilm',
        'filmlab',
        'indielab',
        'indie',
        'film',
        'lab'
      ]
    }
  },
  computed: {
    result() {
      return zxcvbn(this.value, this.dictionary)
    }
  }
}
</script>

<style>
.animated-bar {
  transition: all 0.1s ease-in-out;
}
</style>
